import React from "react";

export default function MetricTogglePills({
    metrics,
    selectedMetric,
    onChange
})
{
    return (
        <div
            style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                marginBottom: "20px"
            }}
        >
            {
                Object.keys(metrics).map(
                    function(key)
                    {
                        const metric =
                            metrics[key];

                        const selected =
                            selectedMetric === key;

                        return (
                            <div
                                title={metric.description}
                                key={key}
                                onClick={
                                    function()
                                    {
                                        onChange(key);
                                    }
                                }
                                style={{
                                    display: "flex",
                                    position: "relative",

                                    height: "34px",
                                    width: "118px",

                                    alignItems: "center",
                                    justifyContent: "center",

                                    //------------------------------------------------
                                    // Flat geometry
                                    //------------------------------------------------
                                    borderRadius: "0px",

                                    cursor: "pointer",

                                    fontSize: "12px",
                                    fontWeight: 600,

                                    transition:
                                        "all 180ms ease",

                                    userSelect: "none",

                                    //------------------------------------------------
                                    // State
                                    //------------------------------------------------
                                    background:
                                        selected
                                            ? `linear-gradient(
                                                180deg,
                                                ${metric.color} 0%,
                                                ${metric.color}dd 100%
                                              )`
                                            : "rgba(255,255,255,0.88)",

                                    color:
                                        selected
                                            ? "#ffffff"
                                            : "#334155",

                                    border:
                                        selected
                                            ? `1px solid ${metric.color}`
                                            : `1px solid ${metric.color}88`,

                                    //------------------------------------------------
                                    // Premium depth
                                    //------------------------------------------------
                                    boxShadow:
                                        selected
                                            ? `0 3px 8px ${metric.color}35,
                                               0 7px 16px rgba(7,28,49,0.10)`
                                            : "0 2px 5px rgba(7,28,49,0.07)",

                                    //------------------------------------------------
                                    // Tiny active instrument edge
                                    //------------------------------------------------
                                    borderBottom:
                                        selected
                                            ? `2px solid ${metric.color}`
                                            : `1px solid ${metric.color}88`
                                }}
                            >
                                {metric.label}
                            </div>
                        );
                    }
                )
            }
        </div>
    );
}